import React, { useEffect } from 'react';
import { Chart } from '@antv/g2';

const TransactionsGroupByRcChart = ({ responseCodes }) => {
  useEffect(() => {

    const formattedData = responseCodes?.map((item) => ({
      count: item.count,
      code: `${item.code} (${item.count})`
    }));

    const chart = new Chart({
      container: 'transactions-group-by-response-codes',
      autoFit: true,
      height: 400,
    });

    chart.options({
      type: 'interval',
      data: formattedData,
      coordinate: { type: 'theta', outerRadius: 0.85 },
      transform: [{ type: 'stackY' }],
      encode: {
        y: 'count',
        color: 'code',
        tooltip: ['code', 'count'],
      },
      legend: {
        color: {
          position: 'right',
          layout: { justifyContent: 'center' },
          itemMarker: 'square',
          itemLabelFontSize: 14,
        },
      },
      style: {
        stroke: '#fff',
        lineWidth: 2,
      },
      labels: [
        {
          text: 'count',
          position: 'outside',
          fontSize: 14,
          fill: '#333',
        },
      ],
      scale: {
        color: {
          range: [
            '#6950E8', // Violeta base
            '#F4A261', // Naranja base
            '#8F6FF7', // Violeta claro
            '#9A6BFF', // Violeta intermedio
            '#C7A4FF', // Violeta suave
            '#FFBC88', // Naranja suave
          ],
        },
      },
      tooltip: {
        title: 'Distribución',
        items: [
          { channel: 'color', name: 'Tipo' }
        ],
      }
    });

    chart.render();

    return () => chart.destroy();
  }, [responseCodes]);

  return (
    <div id="transactions-group-by-response-codes" style={{ width: '100%' }}></div>
  );
};

export default TransactionsGroupByRcChart;
